import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { Login } from './login';

@Component({
    selector: 'login',
    providers: [LoginService],
    template: require('./login.component.html')
})

export class LoginComponent implements OnInit {

    error: boolean = false;
    code: number = 0;
    model = new Login("", "");

    constructor(private _loginService: LoginService, public router: Router) {        
    }

    ngOnInit() {
        
        this.code = Number(localStorage.getItem("code"));
        localStorage.removeItem("code");

        this._loginService.getUserStatus().then(status => {
            localStorage.setItem("userRole", status.role);                           
        });

        //L'API retorna 302 si el login es correcte
        if(this.code == 302) {
            this.router.navigate(['/main','dashboard']);
        }

    }

    onSubmit(value: any) {
        this._loginService.login(value.email, value.password).subscribe((result) => {
            this.code = result.code;
            localStorage.setItem("code", result.code);
            if (result !== null && result.token !== undefined) {
                location.reload();
            }
        }, () => { this.error = true; });
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/login/login.component.ts
 **/